[
    {
        "dayNum": "1",
        "icon": "fire",
        "title": "Opening Ceremony",
        "time": "9.30AM - 10.00AM",
        "description": "Meet the Dean of CS USM, our Sponsor Companies, Project Director and more. Start off with a bang!"
    },
    {
        "dayNum": "1",
        "icon": "plane-departure",
        "title": "Introduction Session",
        "time": "10.00AM - 10.30AM",
        "description": "Find out what you'll need to know and expect in this new journey ahead."
    },
    {
        "dayNum": "1",
        "icon": "brain",
        "title": "Think Tank: Brainstorm Or Brain Jam",
        "time": "10.30AM - 12.30PM",
        "description": "Formulate solutions to a problem. Learn how to refine it, make it sustainable and future-proof."
    },
    {
        "dayNum": "2",
        "icon": "face-laugh-beam",
        "title": "Engagement Session",
        "time": "8.30AM - 9.00AM",
        "description": "It will be a long day ahead for the hackathon and other exciting programs, so let's hype up the mood!"
    },
    {
        "dayNum": "2",
        "icon": "cogs",
        "title": "Prototyping: Ideas To Reality",
        "time": "9.00AM - 11.00AM",
        "description": "Transform your idea into a working model using Figma. Learn how to build epic prototypes and make your idea a reality."
    },
    {
        "dayNum": "2",
        "icon": "mountain",
        "title": "Pitching and Presentation: Take It To The Top",
        "time": "2.30PM - 4.30PM",
        "description": "Perform your best and present your project to the world. Learn the secrets of pitching and how to make people drop their jaws."
    },
    {
        "dayNum": "3",
        "icon": "cloud-arrow-up",
        "title": "Preliminary Round Submission",
        "time": "Before 5.00PM",
        "description": "All teams are expected to submit their projects via their dashboard in a timely manner."
    },
    {
        "dayNum": "3",
        "icon": "glasses",
        "title": "Engagement Session with Tech Changemakers - Mission: Possible",
        "time": "8.00PM - 9.30PM",
        "description": "Connect with speakers who created positive impact with tech to share their experience and expertise."
    },
    {
        "dayNum": "3",
        "icon": "clover",
        "title": "Lucky Draw Session",
        "time": "9.30PM - 9.45PM",
        "description": "Is luck on your side today? Stand a chance to win attractive prizes by following a few simple steps on our <a class=\"text-decoration-underline\" href=\"https://www.facebook.com/vhack.usm/posts/127518033167273\" target=\"_blank\">FB page</a> and <a class=\"text-decoration-underline\" href=\"https://www.instagram.com/p/Carl4s3MoNW/\" target=\"_blank\">IG account</a>!"
    },
    {
        "dayNum": "4",
        "icon": "bolt-lightning",
        "title": "Grand Finale: Top 15 Teams Presentation",
        "time": "9.30AM - 1.00PM",
        "description": "Watch the presentations of creative and innovative project from the top future leaders."
    },
    {
        "dayNum": "4",
        "icon": "handshake",
        "title": "Networking Session: V-Hackers Assemble",
        "time": "8.30PM - 10.00PM",
        "description": "Take a break and get to know the others from all over the world! Exchange thoughts and connect with like-minded individuals."
    },
    {
        "dayNum": "5",
        "icon": "trophy",
        "title": "Closing and Awards Ceremony",
        "time": "9.30AM - 10.30AM",
        "description": "Who will merge as the top and win the many <a class=\"text-decoration-underline\" href=\"./awards.html\">awards</a> in V Hack? Don't miss out this precious moment!"
    }
   
]